angular.module('zippgo.directives').directive('backImg', function() {
	return function(scope, element, attrs) {
		attrs.$observe('backImg', function(value) {
			element.css({
				'background-image': 'url(' + value + ')'
			});
		});
	};
});